<template>
  <div id="_album">
    <div class="album-container">
      <info-block v-if="currentEvent != null && currentEvent.modules != null" :title="$getModuleTitle(currentEvent.modules, 'Gallery')" :desc="$t('networking.description')" :button="null" :url="null">
        <template slot="input">
          <transition name="el-zoom-in-top" mode="out-in">
            <el-input
              v-if="albumType == 0"
              v-model="searchTerm"
              :placeholder="$t('search')"
              :loading="$store.state.eventLoading == 'album'"
              :suffix-icon="$store.state.eventLoading == 'album' ? 'el-icon-loading' : 'el-icon-search'"
              @clear="
                searchTerm = null;
                $store.dispatch('getAlbum', { searchTerm: null, id: currentEvent.id, route: false });
              "
              clearable
            ></el-input>
          </transition>
        </template>
      </info-block>
      <div class="album-type-select">
        <div class="type-button" @click="albumType = 0" :style="albumType == 0 ? 'background-color: ' + currentEvent.color + ';color:white;' : ''">{{ $t("uploads") }}</div>
        <div class="type-button" @click="albumType = 1" :style="albumType == 1 ? 'background-color: ' + currentEvent.color + ';color:white;' : ''">{{ $t("eventMemories") }}</div>
      </div>

      <template v-if="currentAlbum.length == 0 && currentEvent != null && currentEvent.modules && albumType == 0">
        <Nodata :key="albumType + '-nodata-lottie'" :title="$getModuleTitle(currentEvent.modules, 'Gallery')" :description="categoryId == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-gallery-lottie" :loading="loading == 'eventAlbumLoading'" @btnClick="getEventAlbum" :button="albumType == 1 ? undefined : $t('refresh')" />
      </template>


      <transition name="el-fade-in" mode="out-in">
        <div class="album-grid" v-if="albumType == 0">
          <div v-for="(album, index) in currentAlbum" :key="index" class="album-block">
            <a :data-lightbox="album" :data-title="album.title" :href="album.url" v-if="album.type == 0" :style="'background-image: url(' + $imageus + album.url + '?width=1000&height=1000&mode=cover);'" class="album-image"> </a>
            <iframe width="560" v-else height="315" :src="'https://youtube.com/embed/' + getId(album.url)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <div class="album-header" :style="'background-color: ' + currentEvent.color">
              <p class="fullname clamp">
                {{ album.title }}
              </p>
              <!-- <p class="title" v-if="album.title != null ">
                {{ album.title }}
              </p> 
              <p class="title" v-if="album.firmName != null ">
                <b>@ {{ album.firmName }}</b>
              </p> -->
            </div>
            <!-- <div class="bottom-line" ></div> -->
          </div>
        </div>
        <div class="album-grid" v-else>
          <div v-for="(album, index) in currentSocialAlbum" :key="index" class="album-block">
            <a :data-lightbox="album" :data-title="album.owner != null ? album.owner.fullName : 'Katılımcı bulunamadı'" :href="album.image" :style="'background-image: url(' + $imageus + album.image + '?width=1000&height=1000&mode=cover);'" class="album-image"> </a>
            <div class="album-header" :style="'background-color: ' + currentEvent.color">
              <p class="fullname clamp">
                {{ album.owner != null ? album.owner.fullName : "Katılımcı bulunamadı" }}
              </p>
              <!-- <p class="title" v-if="album.title != null ">
                {{ album.title }}
              </p> 
              <p class="title" v-if="album.firmName != null ">
                <b>@ {{ album.firmName }}</b>
              </p> -->
            </div>
            <!-- <div class="bottom-line" ></div> -->
          </div>
        </div>
      </transition>

      <template v-if="currentSocialAlbum.length == 0 && currentEvent != null && currentEvent.modules && albumType == 1">
        <Nodata :key="albumType + '-nodata-lottie'" :title="$getModuleTitle(currentEvent.modules, 'Gallery')" :description="categoryId == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-gallery-lottie" :loading="loading == 'socialLoading'" @btnClick="loadMoreSocial" :button="$t('refresh')" />
      </template>
      <!-- <template >
        <Nodata :key="albumType + '-nodata-lottie'" :title="$t('uploads')" :description="categoryId == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-gallery-lottie" :loading="loading == 'socialLoading'" @btnClick="loadMoreSocial" :button="albumType == 2 ? undefined : $t('refresh')" />
      </template> -->
      <div class="load-more" v-if="albumType == 1 && !disableLoad && currentSocialAlbum.length != 0">
        <el-button :disabled="disableLoad" :loading="loading == 'socialLoading'" :style="{ backgroundColor: currentEvent.color, color: 'white' }" round size="mini" @click="loadMoreSocial">{{ $t("load_more") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import InfoBlock from "../../modules/InfoBlock.vue";

export default {
  name: "AlbumComponent",
  components: {
    InfoBlock
  },
  data() {
    return {
      albumType: 0,
      open: false,
      type: 0,
      searchTerm: null,
      categoryId: null,
      timeout: null,
      disableLoad: false,
      loading: false
    };
  },
  methods: {
    async getEventAlbum() {
      this.loading = "eventAlbumLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchTerm = null;
        this.$store.dispatch("getAlbum", { id: this.currentEvent.id, searchTerm: null, route: false });
        this.loading = false;
      }, 500);
    },
    async loadMoreSocial() {
      this.loading = "socialLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getAlbumSocial", { id: this.currentEvent.id, route: false });
        if (!res.data.hasError) {
          if (res.data.data.items.length == 0) {
            this.disableLoad = true;
          }
        }
        this.loading = false;
      }, 500);
    },
    getId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length === 11 ? match[2] : null;
    },
    searchFilter() {
      this.loading = "eventAlbumLoading";

      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getAlbum", { searchTerm: this.searchTerm, id: this.currentEvent.id, route: false });
        this.loading = false;
      }, 1000);
    },
    openImage(album) {
      $.fancybox.open({
        items: [album.image]
      });
    }
  },
  async created() {
    this.$store.commit("clearSocialAlbum");
    this.$nextTick(async () => {
      await Promise.all([this.$store.dispatch("getAlbum", { id: this.currentEvent.id, route: false }), this.$store.dispatch("getAlbumSocial", { id: this.currentEvent.id, route: false })]);
    });
  },
  computed: {
    currentSocialAlbum() {
      return this.$store.getters.getSocialAlbum;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentAlbum() {
      return this.$store.getters.getAlbum;
    }
  },
  watch: {
    albumType: function() {
      if (this.searchTerm != null) {
        this.searchTerm = null;
        this.searchFilter();
      }
    },
    searchTerm: function() {
      this.searchFilter();
    }
  }
};
</script>

<style lang="less">
#_album {
  display: flex;
  flex-direction: column;
  width: 100%;

  .album-container {
    display: block;
    width: inherit;
    margin: 0 auto;

    .album-search {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      position: relative;
      margin-bottom: 20px;
      gap: 1rem;
      .el-input {
        width: 100%;
      }

      .el-button-group {
        width: 50%;
      }
    }
    .album-type-select {
      background: #ffffff;
      /* Shadow Element */
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 48px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      padding: 8px;
      align-items: center;
      min-height: 48px;
      .type-button {
        transition: all 0.3s;
        user-select: none;
        cursor: pointer;
        background: #268ea6;
        border-radius: 48px;
        text-align: center;
        min-height: 32px;
        font-weight: 700;
        font-size: 14px;
        background-color: white;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 0.2px;
        color: #505763;
      }

      margin-bottom: 1rem;
    }
    .album-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 10px;
      margin: 0px;

      .album-block {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        box-shadow: 0px 2px 10px rgba(38, 142, 166, 0.1);
        background: white;
        border-radius: 12px;
        cursor: pointer;
        &:hover {
          background-color: #fbfbfb;
          transition: all 0.3s ease 0s;
        }

        .album-image {
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          width: 100%;
          height: 100%;
          aspect-ratio: 8/6;
        }

        iframe {
          width: 100%;
          height: 100%;
          aspect-ratio: 8/6;
        }

        .album-header {
          width: 100%;
          padding: 8px;
          background: #268ea6;
          .fullname {
            margin: 0;
            font-size: 16px;
            font-weight: 500;
            color: white;
            &.clamp {
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }

          .title {
            font-size: 13px;
            font-weight: 400;
            color: #505763;
            margin: 4px 0px;
          }
        }

        .bottom-line {
          width: 28%;
          height: 6px;
          border-radius: 3px;
          margin-bottom: -10px;
          margin-top: 10px;
        }
      }
    }
    .load-more {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem 0;
    }
  }
}

@media (max-width: 768px) {
  #_album {
    padding: 0px;
    .album-container {
      padding: 0px 12px;
      .album-grid {
        grid-template-columns: 1fr !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Album.vue